<template>
  <div class="content-main page-loading">
    <div class="loading">
      <van-loading type="spinner" />
      <span>加载中</span>
    </div>
  </div>
</template>

<script>
import { Loading } from 'vant'

export default{
  components: {
    [Loading.name]: Loading
  },
  data(){
    return {

    }
  },
  methods: {
    getUserinfoByCode(){
      var searchParams = new URLSearchParams(window.location.search)
      this.$api.get('/couple/get_userinfo_by_code', {code: searchParams.get("code"), issue: this.$store.state.issue}, res => {
        if(res.code == 200){
          // alert('getUserinfoByCode: ' + JSON.stringify(res))
          var searchParams = new URLSearchParams(window.location.search)
          var destination = searchParams.get("destination")
          // alert('getUserinfo destination: ' + destination)

          if(res.userinfo.paid == 1 && res.userinfo.fill == 1){
            let cpchoose = this.$store.state.cpchoose
            cpchoose.fid = res.form.fid
            cpchoose.mySex = res.form.sex
            cpchoose.myBirth = res.form.birth
            cpchoose.myProvince = res.form.province
            cpchoose.myCity = res.form.city
            cpchoose.myJob = res.form.job
            cpchoose.myIntro = res.form.intro
            cpchoose.myTags = res.form.tags
            cpchoose.myPhone = res.form.phone
            cpchoose.myWechat = res.form.wechat
            cpchoose.partnerSex = res.form.cp_sex
            cpchoose.partnerAge = res.form.cp_age
            cpchoose.partnerCity = res.form.cp_city
            cpchoose.partnerJob = res.form.cp_job
            cpchoose.partnerSurprise = res.form.cp_surprise
            this.$store.commit('updateCpChoose', cpchoose)
          }else if(res.userinfo.paid == 1){
            this.$store.commit('updateCpChooseFid', { fid: res.userinfo.fid })
            let cpchoose = this.$store.state.cpchoose
            cpchoose.mySex = res.form.sex
            this.$store.commit('updateCpChoose', cpchoose)
          }

          this.$store.commit('setUserinfo', {
            openid: res.userinfo.openid,
            headimg: res.userinfo.headimg,
            nickname: res.userinfo.nickname,
            subscribe: res.userinfo.subscribe,
            paid: res.userinfo.paid,
            fill: res.userinfo.fill,
            level: res.userinfo.level,
            block: res.userinfo.block,
            groupon_uid: res.userinfo.groupon_uid,
            destination: destination
          })

        }
      })
    }
  },
  mounted(){
    // var searchParams = new URLSearchParams(window.location.search)
    // alert('destination: ' + searchParams.get("destination"))
    this.getUserinfoByCode()
  }
}
</script>

<style scoped>
.page-loading{
  font-size:28px;
  padding-top:30%;
  height:100vh;
}
/* .loading{
  font-size:12px;
  margin-top:30%;
} */
.van-loading{
  margin:0 auto;
  margin-bottom:15px;
}
</style>
